//下载处理数据流
function DownloadDataStream(res, fileName) {
  let blob = new Blob([res], {
    type: 'application/pdf;charset=UTF-8;',
  }); // 这里的res为后端返回的流数据

  let aLink = document.createElement('a');
  // let name = new Date().getTime()
  let name = fileName;
  aLink.download = name + '.pdf'; // 下载文件的名字

  aLink.href = URL.createObjectURL(blob);
  aLink.click();
}
function getQuestionSet(data, type) {
  let canshu;
  data.forEach((item) => {
    if (item.relationKind == type) {
      canshu = {
        relationId: item.relationId,
        codeType: item.codeType,
      };
    }
  });
  return canshu;
}
export default {
  getQuestionSet,
};
